import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.components.WorkflowWizardPopup.TypeOfDocsStep', {
    title: 'What kind of documents you want to approve?',
    subtitle: 'Pick one type now. You can create more workflows for other types of documents later.',
    other: 'Other (e.g. travel requests or contracts)',
    popular: 'Popular',
});
